<template>
  <footer class="footer" id="contact">
    <div class="container">
      <div class="logo">
        <router-link :to="'/home'"><img src="/logo.svg" alt="Azadi Coin Logo" /></router-link>
      </div>
      <div class="azadi-home">
        <h3>Azadi Academy</h3>
        <nav class="nav">
          <ul>
            <li>
              <router-link :to="'/home'">Home</router-link>
            </li>
            <li>
              <router-link :to="'/category'">Online Tutorials</router-link>
            </li>
            <li>
              <router-link :to="'/live-training'">Live Training</router-link>
            </li>
            <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
      </div>
      <div class="azadi-home">
        <h3 class="w-115">Helpful Links</h3>
        <nav class="nav">
          <ul>
            <li>
              <router-link :to="'/terms-conditions'" class="tnC">Terms And Conditions</router-link>
            </li>
            <li>
             <router-link :to="'/privacy-policy'" class="tnC">Privacy Policy</router-link>
            </li>
        </ul>
      </nav>
      </div>
      <div>
        <div class="footer-social">
          <a
            href="https://discord.gg/RfTkgmYwyd"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/discord.svg" alt="logo" height="30"
          /></a>
          <a
            href="https://www.facebook.com/people/Azadi-Coin/61559293726696/?mibextid=LQQJ4d"
            target="_blank"
            rel="noopener noreferrer"
            ><img src="/fb.svg" alt="logo" height="23"
          /></a>
          <a
            href="https://www.instagram.com/azadicoin?igsh=a3d2Z3p0aThqYTJp"
            target="_blank"
            rel="noopener noreferrer"
            ><img
              src="/insta.svg"
              alt="logo"
              height="27"
              style="transform: scale(1.2)"
          /></a>
          <a
            href="https://x.com/azadicoin"
            target="_blank"
            rel="noopener noreferrer"
            ><img src="/now.svg" alt="logo" height="25"
          /></a>
          <a
            href="https://azadicoin.com/community "
            target="_blank"
            rel="noopener noreferrer"
            ><img src="/tele.svg" alt="logo" height="27"
          /></a>
        </div>
        <p class="text-end">info@azadicoin.com</p>
        <p>Copyright &copy; 2025 Azadi Academy. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.footer {
  background-color: #00103e;
  color: white;
  padding: 1rem 0;
  text-align: center;
}

.container {
  display: flex;
  justify-content: space-between;
  padding: 2rem;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;
}

.logo {
  display: flex;
  gap: 0.2rem;
  align-items: center;
}

.logo img {
  height: 10rem;
  width: 100%;
  margin-right: 10px;
}
.azadi-home {
  align-self: flex-start;
}
.azadi-home h3 {
  padding: 0.4rem 0;
  text-align: left;
  border-bottom: 0.3rem solid #f0c57a;
}
.nav ul {
  margin-top: 1.6rem;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
}
.nav a {
  font-size: 1rem;
  color: white;
  text-decoration: none;
  font-family: Gothic;
}
.nav a:hover {
  text-decoration: underline;
}

.logo-text {
  display: flex;
  font-family: Bebas;
  letter-spacing: 0.1rem;
  flex-direction: column;
  align-items: flex-start;
}

.logo-text h2 {
  font-size: 3rem;
}

.footer-social {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}

.footer-social img {
  width: 30px;
}

p {
  margin-top: 1rem;
  font-family: Gothic
}

.text-end {
  text-align: end;
}

.w-115 {
    width: 115px;
  }

/* Responsive styles for smaller screens */
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    text-align: center;
  }

  .logo-text h2 {
    font-size: 2rem;
  }

  .logo img {
    height: 6rem;
  }

  .footer-social {
    justify-content: center;
    margin-top: 1rem;
  }

  .footer-social img {
    width: 25px;
  }

  p {
    margin-top: 1rem;
    font-size: 0.85rem;
  }
  .azadi-home {
    align-self: center;
  }
  .nav ul {
    align-items: center;
  }
  .azadi-home h3 {
    text-align: center;
  }
  .w-115 {
    width: auto;
  }
}

@media screen and (max-width: 480px) {
  .container {
    padding: 1rem;
  }

  .logo-text h2 {
    font-size: 1.8rem;
  }

  .logo img {
    height: 5rem;
  }

  .footer-social img {
    width: 22px;
  }

  p {
    font-size: 0.8rem;
  }
}
</style>
